
define('template!webshopAttributesKeyView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="header">\n    <div class="title">\n        <div class="name">' +
__e( name ) +
'</div>\n        <div class="meta">\n            ' +
((__t = ( _.i18n('common.code', null, 'Code') )) == null ? '' : __t) +
': <b>' +
__e( key.code ) +
'</b>\n            · <span class="am-badge ' +
((__t = ( key.showInFilters ? 'on' : '' )) == null ? '' : __t) +
'">' +
((__t = ( _.i18n('attributeMatching.filter', null, 'Filter') )) == null ? '' : __t) +
'</span>\n            <span class="am-badge ' +
((__t = ( key.showInAttributes ? 'on' : '' )) == null ? '' : __t) +
'">' +
((__t = ( _.i18n('attributeMatching.attribute', null, 'Attribute') )) == null ? '' : __t) +
'</span>\n        </div>\n        <div class="names">\n            ';
 _.each(names, function (n) { ;
__p += '<span class="lang-name"><b>' +
((__t = ( n.lang )) == null ? '' : __t) +
'</b> ' +
__e( n.name ) +
'</span>';
 }); ;
__p += '\n        </div>\n    </div>\n    <div class="tools">\n        <div class="refresh-region"></div>\n        <div class="edit-region"></div>\n        <div class="delete-region"></div>\n    </div>\n</div>\n<div class="refresh-status am-hint"></div>\n';
 if (!key.showInFilters) { ;
__p += '\n<div class="info">' +
((__t = ( _.i18n('attributeMatching.notAFilter', null, 'Not a webshop filter: tick "Webshop filter" (Edit) to show it on the category pages.') )) == null ? '' : __t) +
'</div>\n';
 } ;
__p += '\n\n<div class="subtabs">\n    <div class="subtab" data-tab="values">' +
((__t = ( _.i18n('attributeMatching.valuesTitle', null, 'Values') )) == null ? '' : __t) +
' (<span class="values-count">0</span>)</div>\n    <div class="subtab" data-tab="fields">' +
((__t = ( _.i18n('attributeMatching.fieldsTitle', null, 'Supplier fields') )) == null ? '' : __t) +
' (<span class="fields-count">0</span>)</div>\n    <div class="subtab" data-tab="supplier-values">' +
((__t = ( _.i18n('attributeMatching.supplierValuesTitle', null, 'Supplier values matching') )) == null ? '' : __t) +
'</div>\n</div>\n\n<div class="pane" data-tab="values">\n    <div class="pane-header">\n        <div class="am-hint">' +
((__t = ( _.i18n('attributeMatching.valuesHint', null, 'The values customers filter on. Supplier values are matched onto them in "Supplier values matching".') )) == null ? '' : __t) +
'</div>\n        <div class="add-value-region"></div>\n    </div>\n    <div class="table">\n        <div class="value head">\n            <div class="col-color"></div>\n            <div class="col-name">' +
((__t = ( _.i18n('common.name', null, 'Name') )) == null ? '' : __t) +
'</div>\n            <div class="col-code">' +
((__t = ( _.i18n('common.code', null, 'Code') )) == null ? '' : __t) +
'</div>\n            <div class="col-param">' +
((__t = ( _.i18n('attributeMatching.paramShort', null, 'Param') )) == null ? '' : __t) +
'</div>\n            <div class="col-count" title="' +
((__t = ( _.i18n('attributeMatching.attributeMatches', null, 'Supplier values shown as this value') )) == null ? '' : __t) +
'">' +
((__t = ( _.i18n('attributeMatching.attributeShort', null, 'Attr.') )) == null ? '' : __t) +
'</div>\n            <div class="col-count" title="' +
((__t = ( _.i18n('attributeMatching.filterMatches', null, 'Supplier values filtered under this value') )) == null ? '' : __t) +
'">' +
((__t = ( _.i18n('attributeMatching.filterShort', null, 'Filter') )) == null ? '' : __t) +
'</div>\n            <div class="col-tools"></div>\n        </div>\n        <div class="values"></div>\n    </div>\n</div>\n\n<div class="pane" data-tab="fields">\n    <div class="pane-header">\n        <div class="am-hint">' +
((__t = ( _.i18n('attributeMatching.fieldsHint', null, 'Supplier attributes (customfields) that mean this attribute. Their values are matched in "Supplier values matching".') )) == null ? '' : __t) +
'</div>\n        <div class="add-fields-region"></div>\n    </div>\n    <div class="table fields"></div>\n</div>\n\n<div class="pane" data-tab="supplier-values">\n    <div class="supplier-values-region"></div>\n</div>\n';

}
return __p
};});

